import { Typography, Box } from '@mui/material';
import React from 'react';
import { ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { Tooltip } from '../../../components';

const FormCustomerGroup: React.FC<any> = ({ formData }) => (
  <>
    <Tooltip title="Selecione grupos de clientes e/ou tags para aplicar o desconto" placement="top-start" sxContainer={{ alignItems: 'flex-start' }}>
      <Box display="flex" alignItems="center">
        <ReferenceArrayInput
          sort={{ field: 'name', order: 'ASC' }}
          // @ts-ignore
          perPage={null}
          source="customerGroupIds"
          reference="chains/chainId/customer-groups"
        >
          <SelectArrayInput style={{ minWidth: 260 }} label="Grupos de clientes" optionText="name" disabled={!!formData.customerIds} />
        </ReferenceArrayInput>

        <Typography variant="body1" sx={{ mx: 2 }}>
          OU
        </Typography>

        <ReferenceArrayInput
          sort={{ field: 'name', order: 'ASC' }}
          filter={{ type: 'client' }}
          // @ts-ignore
          perPage={null}
          source="customerTagIds"
          reference="chains/chainId/tag"
        >
          <SelectArrayInput style={{ minWidth: 260 }} label="Etiquetas de clientes" optionText="name" disabled={!!formData.customerIds} />
        </ReferenceArrayInput>
      </Box>
    </Tooltip>
    {formData.customerIds && (
      <Typography>Há {formData.customerIds.length} clientes selecionados pra esse desconto</Typography>
    )}
  </>
);

export default FormCustomerGroup;